import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { Query, useQuery } from '@tanstack/react-query';

export const REPORT_QUERY_KEY = 'reports.getReport';

type GetReportResponse = Awaited<ReturnType<typeof api.reports.getReport>>;

export const useGetReport = ({
  id,
  refetchInterval,
}: {
  id?: string;
  refetchInterval?: number | false | ((query: Query<GetReportResponse, AxiosApiError>) => number | false);
}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error, refetch } = useQuery<GetReportResponse, AxiosApiError>({
    queryKey: [REPORT_QUERY_KEY, { id, tenantId }],
    queryFn: () => api.reports.getReport(tenantId, id ?? ''),
    enabled: !!id && !!tenantId,
    refetchInterval,
  });

  return {
    report: data?.data.report,
    isLoading,
    error,
    refetch,
  };
};
